import ArrowLeft from '@assets/icons/arrow-left.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native';
import { EMPLOYEE_ROUTES, LOCATION_MANAGER_ROUTES } from '@/navigators/routes';
import { EmployeeNotificationsComponent } from './employee-notifications-component';
import {
  EmployeeStackParams,
  LocationManagerStackParams,
} from '@/navigators/types';
import { ModalContainer } from '@/components/modal-container';
import { PageContainer } from '@/components/page-container';
import { SCREEN_PADDING } from '@/styles';
import { StackNavigationProp } from '@react-navigation/stack';
import { StyleSheet, View } from 'react-native';

interface Props {
  navigation: CompositeNavigationProp<
    StackNavigationProp<
      EmployeeStackParams,
      EMPLOYEE_ROUTES.NotificationSettings
    >,
    StackNavigationProp<
      LocationManagerStackParams,
      LOCATION_MANAGER_ROUTES.ViewEmployeeNotifications
    >
  >;
  route:
    | RouteProp<EmployeeStackParams, EMPLOYEE_ROUTES.NotificationSettings>
    | RouteProp<
        LocationManagerStackParams,
        LOCATION_MANAGER_ROUTES.ViewEmployeeNotifications
      >;
}

export const EmployeeNotificationsScreen: React.FC<Props> = ({ route }) => {
  const {
    params: { userUUID, useModalContainer },
  } = route;

  const navigationHeaderProps = {
    BackButtonIcon: ArrowLeft,
    centerTitle: true,
    showBackButton: true,
    title: i18n.t('notifications'),
  };

  const children = (
    <View style={styles.base}>
      <EmployeeNotificationsComponent employeeUUID={userUUID} />
    </View>
  );

  return useModalContainer ? (
    <ModalContainer
      navigationHeaderProps={navigationHeaderProps}
      showLargeLayoutCloseButton={false}
    >
      {children}
    </ModalContainer>
  ) : (
    <PageContainer navigationHeaderProps={navigationHeaderProps}>
      {children}
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  base: {
    paddingHorizontal: SCREEN_PADDING,
  },
});
